import {Edge, EdgeStyle, Graph, Node} from "@platform/helpers/simple-graph"
import {AnyImageOpHalData, ImageOpHalData} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/hal/image-op-hal-data"
import {isHalImagePhysicalRef, isHalImageVirtualRef} from "@cm/hal"

export const simpleGraphFromImageOpHalData = (imageOpHal: AnyImageOpHalData): Graph => {
    const edgeStyle = new EdgeStyle("solid", "none", "standard")
    const simpleNodeByNode = new Map<AnyImageOpHalData, Node>()
    const nodes: Node[] = []
    const edges: Edge[] = []
    const traverse = (value: AnyImageOpHalData) => {
        let node = simpleNodeByNode.get(value)
        if (!node) {
            const nodeColor = /*value instanceof ImageOpPerPixelFnHalData && !!value.isForwardingTo ? "#ffc0c0" :*/ value.cachingEnabled ? "#c0ffc0" : "#c0c0ff"
            let nodeLabel = `${value.debugId}` // (${value.updatesBeforeInvalidation})`
            nodeLabel += `\n${value.constructor.name}`
            if (value instanceof ImageOpHalData) {
                const descriptor = value.descriptor
                nodeLabel += `\n${descriptor.width}x${descriptor.height} ${descriptor.channels}ch`
                if (descriptor.batching) {
                    nodeLabel += `\nBatching: ${descriptor.batching.numPatches.x}x${descriptor.batching.numPatches.y} of ${descriptor.batching.patchSize.width}x${descriptor.batching.patchSize.height}`
                }
                const outputImagePtr = value.hasOutputImage ? value.outputImagePtr.outputImagePtr : undefined
                if (isHalImageVirtualRef(outputImagePtr)) {
                    const outputImageStats = outputImagePtr.ref.stats
                    nodeLabel += `\nvirtual, ${outputImageStats.allocatedPages.length} pages (${outputImageStats.lockedPages.length} locked / ${outputImageStats.sharedPages.length} shared)`
                } else if (isHalImagePhysicalRef(outputImagePtr)) {
                    nodeLabel += `\nphysical`
                } else {
                    nodeLabel += `\nno image`
                }
            }
            node = new Node(nodeLabel, nodeColor)
            nodes.push(node)
            simpleNodeByNode.set(value, node)
            if (value instanceof ImageOpHalData) {
                for (const sourceImage of value.sourceImages) {
                    const sourceNode = traverse(sourceImage)
                    edges.push(new Edge(sourceNode, node, edgeStyle, undefined, undefined))
                }
            }
        }
        return node
    }
    traverse(imageOpHal)
    const graph = new Graph()
    graph.rootNodes = nodes
    graph.edges = edges
    return graph
}
